export default __webpack_public_path__ + "static/media/upArrow.b5afb8cd.svg";